import Vue from "vue";
import axios from "axios";
import BootstrapVue from "bootstrap-vue";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";
import "./assets/styles/main.scss";
import msal from "vue-msal";
import Chart from "chart.js";
import VueSvgGauge from "vue-svg-gauge";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import "./assets/styles/login.css";

import App from "./App.vue";
import router from "./routes";
import store from "@/store";

Chart.defaults.global.legend.display = false;
Vue.use(BootstrapVue);
Vue.use(VueSvgGauge);
Vue.use(Loading);
Vue.use(require("vue-moment"));

Vue.use(msal, {
  auth: {
    clientId: "721afa5a-09e1-43ee-ab76-f6bc089e0c2a",
    authority:
      "https://coatsdigital.b2clogin.com/coatsdigital.onmicrosoft.com/B2C_1A_signup_signin",
    knownAuthorities: ["https://coatsdigital.b2clogin.com"],
    validateAuthority: false,
    redirectUri: process.env.VUE_APP_SSO_URL,
    navigateToLoginRequestUrl: false,
    onAuthentication(ctx, error, response) {
      console.log("onAuthentication-error", error);
      console.log("onAuthentication-response", response);
      let errorCode = error.message.split(":")[0];
      store.commit(
        "SET_SIGNIN_ERROR",
        errorCode +
          "- Application not part of the organization. Please contact the administrator"
      );
    },
    onToken(ctx, error, response) {
      console.log("error-token", error);
      console.log("response-token", response);
      signInODIC(response);
    }
  },
  request: {
    scopes: ["openid", "profile"],
    extraQueryParameters: {
      req_cd_application_id: "1d9195db-da97-44fb-83a0-267dc3fd3007"
    }
  },
  cache: {
    cacheLocation: "localStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
  }
});

function signInODIC(response) {
  try {
    store.dispatch("loginODIC", {
      response
    });
  } catch (error) {
    console.log(error);
  }
}

Vue.config.productionTip = false;
import Footer from "@/components/Footer";
Vue.component("Footer", Footer);
axios.defaults.headers.common["Accept"] = "application/json";
axios.defaults.baseURL = process.env.VUE_APP_BACKEND_API_URL;
axios.defaults.withCredentials = true;
new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount("#app");
